import { Phase, type Player, type Room } from '@infiltre/shared';
import { FinishedScreen } from './round-result/FinishedScreen';
import { NoVerdictScreen } from './round-result/NoVerdictScreen';
import { VerdictScreen } from './round-result/VerdictScreen';

export type RoundResultProps = {
  room: Room;
  eliminated: Player | null;
  onContinue: () => void;
  continueLabel: string;
  /** Optional rematch CTA — only meaningful on the finished screen. */
  onRematch?: () => void;
  onShowRecap?: () => void;
  recapCount?: number;
};

/**
 * Round result + game finished. Three branches:
 *  - `Finished` → `FinishedScreen` (cork dossier + AFFAIRE CLOSE stamp).
 *  - Player eliminated → `VerdictScreen` (pinned mugshot + magenta cross).
 *  - Tie / no-eliminate → `NoVerdictScreen` (dossier reporté stamp + cast).
 */
export const RoundResult = ({
  room,
  eliminated,
  onContinue,
  continueLabel,
  onRematch,
  onShowRecap,
  recapCount,
}: RoundResultProps) => {
  const finished = room.phase === Phase.Finished;

  if (finished) {
    return (
      <FinishedScreen
        room={room}
        onContinue={onContinue}
        continueLabel={continueLabel}
        onRematch={onRematch}
        onShowRecap={onShowRecap}
        recapCount={recapCount}
      />
    );
  }

  if (eliminated) {
    return (
      <VerdictScreen
        room={room}
        eliminated={eliminated}
        onContinue={onContinue}
        continueLabel={continueLabel}
      />
    );
  }

  return <NoVerdictScreen room={room} onContinue={onContinue} continueLabel={continueLabel} />;
};
